const domainDetails = (domainSlug) => {

  var subdomain = process.env.REACT_APP_SUB_DOMAIN;
  var exixtsDomain = ["investor","app"];
  if (exixtsDomain.includes(domainSlug)) {
    return `${process.env.REACT_APP_BUCKET_URL}/fund/${domainSlug}/logo.png`;
  } else {
    return `${process.env.REACT_APP_BUCKET_URL}/fund/app/logo.png`;
  }
};

export default domainDetails;
